import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteMediaPackage } from '~/services/MediaService';

import { mediaPackageQueryKeys } from './mediaQueryKeys';

/** Removes a media package. The assets it bundled are left in place. */
export function useDeleteMediaPackage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (mediaPackageId: string) => deleteMediaPackage(mediaPackageId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: mediaPackageQueryKeys.all }),
  });
}
